export default "__VITE_ASSET__LGWS9o$w__"